import { colors } from '@ardoq/design-tokens';
import { Box } from '@ardoq/layout';
import { UnstyledLink } from '@ardoq/link';
import { Text } from '@ardoq/typography';
import styled from 'styled-components';

const ScenarioChipSurface = styled(Box)`
  background-color: ${colors.surfaceScenario};
`;

type ScenarioChipProps = {
  children: string;
};

export const ScenarioChip = ({ children }: ScenarioChipProps) => (
  <ScenarioChipSurface
    borderRadius="full"
    paddingX="small"
    paddingY="xxsmall"
    minWidth="0"
  >
    <Text variant="caption" color="textOnInverted" truncate>
      {children}
    </Text>
  </ScenarioChipSurface>
);

export const LogoLink = styled(UnstyledLink)`
  display: flex;
  flex-shrink: 0;
  color: inherit;
  text-decoration: none;
`;
